<div class="totalWins">
  <h3 class="mobile-hide">{{'static.totalWins' | translate}}</h3>
  <span class="mobile-hide" *ngIf="jackpotSum && currency && currency.Code">{{jackpotSum | currency: currency.Code:currency.Symbol:'0.0':(subscriptionsService.countryCodeValue || 'en')}}</span>
  <span class="mobile-hide" *ngIf="!jackpotSum && currency && currency.Code">{{345550484 | currency: currency.Code:currency.Symbol:'0.0':(subscriptionsService.countryCodeValue || 'en')}}</span>
  <h3>{{'static.totalJackpots' | translate}}</h3>
  <span *ngIf="!jackpotSum && currency && currency.Code">{{345550484 | currency: currency.Code:currency.Symbol:'0.0':(subscriptionsService.countryCodeValue || 'en')}}</span>
  <span *ngIf="jackpotSum && currency && currency.Code">{{jackpotSum | currency: currency.Code:currency.Symbol:'0.0':(subscriptionsService.countryCodeValue || 'en')}}</span>
  <hr/>
  <div>{{'static.youLike' | translate}}</div>
  <button *ngIf="userService.userData === undefined" (click)="openRegister();" class="przycisk medium green">{{'static.signupnow' | translate}}</button>

  <button *ngIf="userService.userData" id="homepage-banner-play" class="przycisk medium green" [ngClass]="{'disabled-btn' : isLoadingButton }"
          (click)="openAllLotteries();">{{ 'home.playNow' | translate }}
  </button>
</div>
